import { render, staticRenderFns } from "./Desenvolvedor.vue?vue&type=template&id=a17b69d4&"
import script from "./Desenvolvedor.vue?vue&type=script&lang=ts&"
export * from "./Desenvolvedor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports